module.exports = __webpack_public_path__ + "img/logo.d5dc27af.png";